<template>
  <div class="form-dossier">

    <!-- ── État : contrat signé ── -->
    <template v-if="contractStatus">
      <div class="signed-banner">
        <div class="signed-icon">✓</div>
        <p class="signed-title">Contrat signé</p>
        <p class="signed-sub">Vous avez reçu votre contrat signé par mail.</p>
        <button class="p-button btnForm resend-contract" @click="sendContratPdf">
          Vous n'avez pas reçu votre contrat ?
        </button>
      </div>

      <button @click="goToHomeEleve" class="p-button btnForm home" style="margin-top: 5px">
        Retourner à l'accueil
      </button>
    </template>

    <!-- ── État : contrat à signer ── -->
    <template v-if="!contractStatus">
      <div :class="['contractContainer', { expanded: isExpanded }]">
        <button id="expend-contract" class="p-button btnForm btn-xs" @click="toggleExpand">
          {{ isExpanded ? 'Réduire' : 'Agrandir' }}
        </button>
        <template v-if="social != 'Salarié' && social != 'Sans emploi'">
          <Contrat
            :age="ageEleve"
            :user="dataForm"
            :fonc="fonc"
            :agence="agence"
            :questions="contract.questions"
            :social="social"
            :contractStatus="contractStatus"
            :contract="contract"
          />
        </template>
        <template v-else>
          <ContratPro
            :age="ageEleve"
            :user="dataForm"
            :fonc="fonc"
            :agence="agence"
            :questions="contract.questions"
            :social="social"
            :contractStatus="contractStatus"
            :contract="contract"
          />
        </template>
      </div>
    </template>

  </div>

  <!-- ── Rétractation + signature ── -->
  <template v-if="!contractStatus">
    <div class="retract-row">
      <input
        type="checkbox"
        id="retractContract"
        class="retract-checkbox"
        :checked="$store.state.retractContract"
        @change="$store.commit('setRetractContract', $event.target.checked)"
      />
      <label for="retractContract">Je renonce à mon délai de rétractation.</label>
    </div>

    <div class="footer-form">
      <div class="sign-card">
        <div class="sign-fields">
          <div class="sign-field">
            <label for="CodeSignature">Code reçu par email</label>
            <input
              type="text"
              name="codeSignature"
              id="CodeSignature"
              placeholder="Code reçu"
              @input="$emit('updateCodeSignature', $event.target.value)"
            />
          </div>
          <div class="sign-field" v-if="ageEleve < 18">
            <label for="CodeParent">Code parent</label>
            <input
              type="text"
              name="code"
              id="CodeParent"
              placeholder="Code parent"
              :value="codeParentForm"
              @input="$emit('updateCodeSignatureParent', $event.target.value)"
            />
          </div>
        </div>
        <button class="p-button btnForm sign-btn" @click="signContract">
          Signer le contrat
        </button>
      </div>

      <div class="footer-bottom">
        <div class="btnForm">
          <b-button @click="cancelStep" class="btnForm">Retour</b-button>
        </div>
        <p class="resendMail">
          Vous n'avez pas reçu le mail ?
          <button @click="resendMail" class="button-link">Renvoyer</button>
        </p>
      </div>
    </div>
  </template>
</template>

<script>
import Contrat from "../contrat/Contrat.vue";
import ContratPro from "../contrat/ContratPro.vue";

export default {
  name: "FormulairesStep5",
  components: {
    Contrat,
    ContratPro,
  },
  props: {
    step: Number,
    dataForm: Object,
    fonc: Array,
    agence: Object,
    contract: Object,
    social: String,
    contractStatus: Boolean,
    ageEleve: Number,
    code: String,
    codeParentForm: String,
    resendMail: Function,
    signContract: Function,
    sendContratPdf: Function,
    goToHomeEleve: Function,
    cancelStep: Function,
    updateCodeSignature: Function,
    updateCodeSignatureParent: Function,
  },
  mounted() {
    console.log("social : ", this.social);
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style scoped>

/* ── Contrat signé ── */
.signed-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 1rem 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.signed-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #07989f;
  color: #fff;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.signed-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.25rem;
}

.signed-sub {
  font-size: 0.9rem;
  color: #718096;
  margin: 0 0 1rem;
}

button.resend-contract {
  font-size: 0.82rem;
  margin-bottom: 0;
  color: #fff;
  text-decoration: none;
}

button.home {
  display: block;
  margin: 1.25rem auto 0;
}

/* ── Contrat viewer ── */
.form-dossier {
  margin: 0 auto 10px;
  max-width: 960px;
}

div.contractContainer {
  width: 100%;
  margin: auto;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  padding: 20px;
  border-radius: 10px;
  height: calc(100% - 40px);
  position: relative;
  padding-top: 0;
  box-shadow: inset 1px 1px 22px #c7c7c7;
  margin-top: 1rem;
}

#expend-contract.p-button.btnForm {
  position: sticky;
  justify-self: start;
  border-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: solid #fff 2px;
  padding: 5px 5px 3px;
  font-size: 0.9em;
  margin-bottom: 20px;
  margin-top: 0;
  top: 0;
  left: 0;
}

div.contractContainer:not(.expanded) #expend-contract.p-button.btnForm {
  display: none;
}

div.contractContainer.expanded {
  position: fixed;
  top: 0;
  z-index: 3;
  background-color: #fffa;
  backdrop-filter: blur(5px);
  left: 0;
  width: 100vw;
  border-radius: 0;
  bottom: 0;
  border: none;
  padding: 118px 20px 20px;
  height: 100vh;
  margin-top: 0;
}

div.contractContainer.expanded > div {
  background: #fff;
  padding: 20px;
  border-radius: 20px;
  overflow: scroll;
  max-height: calc(100% - 50px);
  box-shadow: inset 1px 1px 22px #c7c7c7;
  max-width: 1366px;
  margin: 0 auto;
}

div.contractContainer.expanded #expend-contract.p-button.btnForm {
  border-radius: 10px;
}

@media screen and ((max-width:1024px) or (max-height:768px)) {
  div.contractContainer:not(.expanded) #expend-contract.p-button.btnForm {
    display: inline-flex;
  }
}

/* ── Rétractation ── */
.retract-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  padding: 0;
  margin: 8px 0 4px;
}

.retract-checkbox {
  appearance: none !important;
  -webkit-appearance: none !important;
  width: 1.2em !important;
  height: 1.2em !important;
  min-width: 1.2em !important;
  max-width: 1.2em !important;
  border: 2px solid #07989f !important;
  border-radius: 4px !important;
  background-color: #fff !important;
  cursor: pointer;
  flex-shrink: 0;
  position: static !important;
  padding: 0 !important;
  transition: background-color 0.15s ease;
}

.retract-checkbox:checked {
  background-color: #07989f !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23ffffff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round' d='M3 8l3.5 3.5L13 4.5'/%3E%3C/svg%3E") !important;
  background-size: 80% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

.retract-row label {
  position: static !important;
  top: auto !important;
  left: auto !important;
  background: transparent !important;
  font-size: 0.9em !important;
  color: #333;
  cursor: pointer;
  margin: 0;
}

/* ── Signature card ── */
.sign-card {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  max-width: 600px;
  margin: 0 auto;
  background: #f7fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
}

.sign-fields {
  display: flex;
  gap: 10px;
  flex: 1;
  flex-wrap: wrap;
}

.sign-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 120px;
}

.sign-field label {
  font-size: 0.75rem;
  color: #718096;
  font-weight: 500;
  position: static !important;
  top: auto !important;
  left: auto !important;
  background: transparent !important;
}

.sign-field input {
  padding: 7px 12px;
  border: 1.5px solid #07989f;
  border-radius: 20px;
  font-size: 0.9rem;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  box-shadow: none;
  width: 100%;
}

.sign-field input:focus {
  box-shadow: 0 0 0 3px rgba(7, 152, 159, 0.15);
}

.sign-btn {
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Footer bottom ── */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 600px;
  margin: 6px auto 0;
}

p.resendMail {
  font-size: 0.82rem;
  color: #718096;
  margin: 0;
}

button.button-link {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  background: transparent;
  text-decoration: underline;
  color: #07989f;
  cursor: pointer;
  font-size: inherit;
}

div.btnForm {
  display: flex;
  justify-content: flex-start;
}

@media screen and (max-width: 768px) {
  .sign-card {
    flex-direction: column;
    align-items: stretch;
  }

  .sign-btn {
    width: 100%;
    justify-content: center;
  }

  div.contractContainer {
    padding: 10px;
    height: calc(100% - 30px);
    min-height: 50px;
    margin-top: 0;
  }
}
</style>
